<template>
  <div>
    <div
      class="classitems clearfix"
      v-for="(item) in evaluatelist"
      :data-id="item.id"
      :key="item.id"
    >
      <div class="pic fl">
        <div class="imgs">
          <img :src="item.video.image" alt />
        </div>

        <div class="type" v-if="item.video.type==1">点播课</div>
        <div class="type" v-if="item.video.type==2">直播课</div>
        <div class="type" v-if="item.video.type==3">线下课</div>
        <h3>{{item.video.title}}</h3>
        <div class="time">{{item.date}}</div>
      </div>
      <div class="infos clearfix fr">
        <div class="evaluation" v-if="item.video_comment">
          <h2>
            <span>课程评价</span>
            <el-rate
              v-model="item.video_comment.score"
              disabled
              show-score
              text-color="#ff1c1c"
              :score-template="item.video_comment.score.toString()"
            ></el-rate>
          </h2>
          <p>{{item.video_comment.content}}</p>
        </div>
        <div class="evaluation" v-if="item.teacher_comment">
          <h2>
            <span>讲师评价</span>
            <el-rate
              v-model="item.teacher_comment.score"
              disabled
              show-score
              text-color="#ff1c1c"
              :score-template="item.teacher_comment.score.toString()"
            ></el-rate>
          </h2>
          <p>{{item.teacher_comment.content}}</p>
        </div>
        <div class="evaluation" v-if="item.school_comment">
          <h2>
            <span>机构评价</span>
            <el-rate
              v-model="item.school_comment.score"
              disabled
              show-score
              text-color="#ff1c1c"
              :score-template="item.school_comment.score.toString()"
            ></el-rate>
          </h2>
          <p>{{item.school_comment.content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Rate } from "element-ui";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
export default {
  components: {
    [Rate.name]: Rate
  },
  data() {
    return {
      evaluatelist: [],
      page: 1
    };
  },
  methods: {
    evaluate() {
      var data = utilFile.encrypt(
        JSON.stringify({
          page: this.page
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.getCommentList?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          if (res.data.data != undefined) {
            let arr = JSON.parse(utilFile.decrypt(res.data.data));
            arr.forEach(item => {
              if (item.school_comment) {
                item.school_comment.score = getPointNum.getPointNum(
                  item.school_comment.score,
                  2
                );
              }
              if (item.teacher_comment) {
                item.teacher_comment.score = getPointNum.getPointNum(
                  item.teacher_comment.score,
                  2
                );
              }
              if (item.video_comment) {
                item.video_comment.score = getPointNum.getPointNum(
                  item.video_comment.score,
                  2
                );
              }
            });
            this.evaluatelist = arr;
          }
        }
      });
    }
  },
  mounted() {
    this.evaluate();
  }
};
</script>

<style scoped>
.classitems {
  padding: 25px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 50px;
}

.classitems:last-of-type {
  border: 0;
}

.classitems .pic {
  width: 210px;
  position: relative;
  border-radius: 6px;

  margin-bottom: 15px;
}

.classitems .pic .imgs {
  overflow: hidden;
  margin-bottom: 15px;
  height: 126px;
  overflow: hidden;
}

.classitems .pic img {
  min-height: 100%;
}

.classitems .pic .type {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.6);
  left: 10px;
  top: 10px;
}

.classitems .pic h3 {
  box-sizing: border-box;
  padding: 0 19px;
  line-height: 1.5em;
  margin-top: 16px;
  text-align: center;
  margin-bottom: 15px;
  font-weight: bold;
}

.classitems .pic .time {
  font-size: 13px;
  color: #999999;
  text-align: center;
  line-height: 1em;
}

.classitems .infos {
  width: 690px;
  text-align: left;
}

.classitems .infos h2 {
  text-align: left;
  margin-bottom: 20px;
}

.classitems .infos h2 span {
  display: inline-block;
}

.classitems .infos p {
  font-size: 14px;
  color: #666666;
  line-height: 1.6em;
  margin-bottom: 33px;
}
</style>
<style>
.classitems .infos .el-rate__icon {
  font-size: 26px;
}
.classitems .el-rate {
  display: inline-block;
  margin-left: 40px;
}

.classitems .el-rate__text {
  font-size: 24px;
  font-weight: bold;
}
</style>